import { AddressDetailModel, ProductsResponse } from 'app/shared/models/index';

export interface NbnProductsResponse extends ProductsResponse {
  serviceQualification: ServiceQualification;
}

export type NbnAddressResponse = NbnAddressSuccessResponse | NbnAddressErrorResponse;

export const isNbnAddressSuccessResponse = function (res: NbnAddressResponse): res is NbnAddressSuccessResponse {
  return 'addressLong' in res;
};

export const isNbnAddressErrorResponse = function (res: NbnAddressResponse): res is NbnAddressErrorResponse {
  return !('addressLong' in res);
};

export interface NbnAddressSuccessResponse {
  addressLong: string;
}

export interface NbnAddressErrorResponse {
  code?: string;
  message?: string;
}

export interface ServiceQualification {
  nbn: NbnDetails;
}

export interface NbnDetails {
  serviceQualificationId: string;
  result: string;
  nbnLocation: NbnLocation[];
  serviceType: string;
  serviceOrderType: string;
  serviceClass: string;
  additionalData: any;
  alternativeServiceType?: boolean | string;
}

export interface NbnLocation {
  locationId: string;
  addressLong: string;
  addressStructured: AddressDetailModel;
}
